import { backendFetch, backendPostJsonWithResult } from '../../../backend/backend';
import React, { useEffect, useState, Fragment } from 'react';
import { Stack, TableRow, Button } from '@mui/material';
import Subtitle from '../../ui/Subtitle';
import { TSCell, TSTable } from '../../ui/TableStructure';
import BaseLeagueTable from '../../tables/BaseLeagueTable';
import ScoringStructureSection from '../../tables/ScoringStructureSection';
import Selector from '../../ui/Selector';

const StatsLeagueTablePredictor = () => {
	const [leagueTable,setLeagueTable]=useState([]);
	const [scoringStructure,setScoringStructure]=useState({structure:[],maxScoresToCount:0});
	const [fetched,setFetched]=useState(false);
	const [activePlayers,setActivePlayers]=useState([]);
	const [selectedResults,setSelectedResults]=useState([]);

	const clearResults=(players) => {
			const results=[];
			results[0]=Array(players.length).fill('');
			results[1]=Array(players.length).fill('');
			setSelectedResults(results);
	}

	useEffect(()=>{
		async function fetchData() {
			const league=await backendFetch('league?season=active');
			setLeagueTable(league);
			const scoring=await backendFetch('scoring?season=active');
			setScoringStructure(scoring);
			const players=await backendFetch('players?active=true');
			setActivePlayers(players.map((p)=>p.name));
			clearResults(players);
			setFetched(true);
		}
		fetchData();
	},[]);

	// Update league table as results change
	useEffect(()=>{
		async function fetchUpdate() {
			if (fetched) {
				const resultSubmissions=[];
				for(let game=0;game<2;game++) {
					const resultSubmission={};
					activePlayers.forEach((player,i)=>{
						if (selectedResults[game][i]>0)
							resultSubmission[player]=selectedResults[game][i];
					});
					if (Object.entries(resultSubmission).length>0)
						resultSubmissions.push(resultSubmission);
				}
				const league=await backendPostJsonWithResult(null,null,'league/predict',resultSubmissions);
				setLeagueTable(league);
			}
		}
		fetchUpdate();
	},[selectedResults,activePlayers,fetched]);

	const resultSelector = (game,i) =>
		<Selector
			onChange={(v) => selectResults(game,i,v)}
			value={selectedResults[game][i]===undefined?"":selectedResults[game][i]}
			key={i}
			values={activePlayers.filter(Boolean).map((_,j)=>j+1).filter((j)=>!selectedResults[game].includes(j) || selectedResults[game][i]===j) }
			ordinalValues
			clearItem />

			// Need game 1 and 2!
	const selectResults = (game,index,result) => {
		setSelectedResults(results => {
			results[game][index]=result;
			return[...results];
		});
	}

	const resultCells=(game) => activePlayers.map((_,i) => {
		return (
			<TableRow key={i}>
				<TSCell>{activePlayers[i]}</TSCell>
				<TSCell>{resultSelector(game,i)}</TSCell>
			</TableRow>
		);
	});

	return(
		<Stack>
			{ fetched && 
				<Fragment>
					<Stack spacing="0">
						<Subtitle text="League Table"/>
						<BaseLeagueTable leagueTable={leagueTable} />
					</Stack>
					<Stack direction="row">
						<TSTable title="Game 1" headings={["Player","Result"]} sx={{width:{sm:575}}}>
							{resultCells(0)}
						</TSTable>
						<TSTable title="Game 2" headings={["Player","Result"]} sx={{width:{sm:575}}}>
							{resultCells(1)}
						</TSTable>
						<Button onClick={()=>{clearResults(activePlayers)}}>Clear</Button>
					</Stack>
					<ScoringStructureSection scoringStructure={scoringStructure} />
				</Fragment>
			}
		</Stack>
	);
}

export default StatsLeagueTablePredictor;


